let accountId: string | null = null;

/**
 * This is used instead of decoding the auth token to allow unauthenticated
 * users/assessments access the current account.
 */
export const currentAccountId = {
  get: () => accountId,
  set: (id?: string | null) => {
    accountId = id ?? null;
  },
};
